import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { Button, Col, Dropdown, MenuProps, Row, notification, Tag } from 'antd';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfSoftSkillontext,
  UserSkillDataContext,
} from '../../../../../../../context';
import EditSkill from '../edit-skill';
import { useParams } from 'react-router-dom';
import DeleteModal from '../../../../../modal/delete';

interface SkillDetailProps {
  skill_id: number;
  skill_name: string;
  level: number;
  certificate: number | string;
  experience_year: number | string;
  data: number;
  skill_category: Array<any>;
  show_in_resume: boolean;
}

const SkillDetail: React.FC<SkillDetailProps> = ({
  skill_id,
  skill_name,
  level,
  certificate,
  experience_year,
  data,
  skill_category,
  show_in_resume
}: SkillDetailProps): JSX.Element => {
  const [iseditable, setIsEditable] = useState<boolean>(false);
  const { userSkillData, setUserSkillData } = useContext(UserSkillDataContext);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const { numberOfSoftSkills, setNumberOfSoftSkills } = useContext(NumberOfSoftSkillontext);

  const openNotification = (notificationType: 'success' | 'info' | 'warning' | 'error', skill_name: string) => {
    notification[notificationType]({
      message: notificationType === 'info' ? `Deleting skill ${skill_name}` : (notificationType === 'success' ? `Deleted skill ${skill_name} Successfully` : (notificationType === 'error' ? `An error occured while deleting skill ${skill_name}` : "")),
    });
  };
  const handleDelete = () => {
    openNotification('info', skill_name);
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/skills';
      reqBody = { profile_id: employeeId, skill_id, status: 3 };
    } else {
      url = '/api/v1/profile/skills';
      reqBody = { skill_id, status: 3 };
    }
    axiosInstance.post(url, reqBody).then((response) => {
      let userSkills: Array<any> = [];
      if (response.data.skills.length !== 0) {
        userSkills = response.data.skills.filter(
          (skill: any) =>
            skill['status']['id'] === 1 && skill['skill_type']['id'] === 2
        );
        const orderedSkills = response.data.order_soft_skills.map((skillId: number) =>
          userSkills.find((userSkill: any) => userSkill.skill_id === skillId)
        ).filter((item: any) => item !== undefined);
        setUserSkillData(orderedSkills);
      } else {
        setUserSkillData(response.data.skills);
      }
      setNumberOfSoftSkills(userSkills.length);
      openNotification('success', skill_name);
    }).catch((error) => {
      openNotification('error', skill_name);
    });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  return (
    <div>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      {iseditable ? (
        <EditSkill
          {...{ skill_id, level, certificate, experience_year, setIsEditable, show_in_resume }}
        />
      ) : (
        <Row
          key={skill_id}
          className={styles.row}
          gutter={{ xs: 8, sm: 16 }}
          style={{ margin: '5px', marginBottom: '10px' }}
        >
          <div style={{ display: "flex", alignItems: "center", position: "absolute", bottom: "5px", right: "5px" }}>
            {
              show_in_resume ? (
                <Tag color="success">
                  Show in resume: Yes
                </Tag>
              ) : (
                <Tag color="error">
                  Show in resume: No
                </Tag>
              )
            }
          </div>
          <Col span={12}>
            <Row>
              <h1 className={styles['skill-text']}>
                <b>{skill_name}</b>
              </h1>
            </Row>
            <Row>
              {skill_category.map((category: any, index: number) => {
                if (index === skill_category.length - 1) {
                  return (
                    <p className={styles['category-name']} key={index}>
                      {category['name']}
                    </p>
                  );
                } else {
                  return (
                    <p className={styles['category-name']} key={index}>
                      {category['name']},&nbsp;
                    </p>
                  );
                }
              })}
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Level : </span>
                  <span className={styles.value}>{level}</span>
                </p>
              </Col>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Experiences (Years) : </span>
                  <span className={styles.value}>{experience_year}</span>
                </p>
              </Col>
            </Row>
            <p>
              <span className={styles.title}>Certificates : </span>
              <span className={styles.value}>
                {certificate === '1' ? 'Yes' : 'No'}
              </span>
            </p>
          </Col>
          <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
            <Button
              type="text"
              style={{
                position: 'absolute',
                right: '5px',
                border: 'hidden',
                textDecoration: 'blue',
                top: "10px"
              }}

            >
              <img
                src="/more_vert.png"
                style={{
                  marginLeft: 'auto',
                  marginRight: '0px',
                  height: '15px',
                  width: '5px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Dropdown>
        </Row>
      )}
    </div>
  );
};

export default SkillDetail;
